import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { useAppStoreDispatch } from '../../../store';
import axios from '../../../utils/api/axiosInstance';
import { addSelectedUser } from '../store';
import styles from './Users.module.scss';

function Users() {
  const [users, setUsers] = useState<string[]>([]);
  const navigate = useNavigate();
  const dispatch = useAppStoreDispatch();
  useEffect(() => {
    async function fetchAllUsers() {
      const results = await axios.get('api/admin/users');
      setUsers(results.data as [string]);
    }

    fetchAllUsers();
  }, []);

  const onUserRowClickHandler = (user: string) => {
    //console.log(user);
    dispatch(addSelectedUser(user));
    navigate(`user/${user}`);
  };

  return (
    <Box className={styles['users-container']}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell> </TableCell>
              <TableCell>Username</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user, index) => (
              <TableRow
                onClick={() => onUserRowClickHandler(user)}
                key={index}
                sx={{ 
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  }
                }}
              >
                <TableCell>{index}</TableCell>
                <TableCell>{user}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Users;
